import { isCallScribeWindowView } from 'components/CallScribe/callScribeWindow';
import { isSoftphonePopupView } from 'components/CallScribe/popout';

export const isAuxiliaryCallView = (): boolean =>
  isCallScribeWindowView() || isSoftphonePopupView();
